import React from "react";
import styled from "styled-components";
import { ReactComponent as DownloadIcon } from "assets/images/download_icon.svg";
import GridSkeletonLoaderComponent from "./GridSkeletonLoaderComponent";
import LineChartSkeletonLoader from "./LineChartSkeletonLoader";
import { ReactComponent as DownArrowIcon } from "assets/images/menu_downarrow.svg";
import i18n from "i18next";
import { keyframes } from "styled-components";

const SkeletonLoaderContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-top: 12px;
  .chartjs-buffer {
    margin-top: -3px;
  }
`;

const LineChartSkeletonLoaderDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: -25px;
`;

const LineChartSkeletonLoaderContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 120px;
  //margin-bottom: 15px;
  margin-top: 10px;
`;

const LineChartSkeleton = styled(LineChartSkeletonLoader)`
  height: 100%;
`;

const DownloadButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  z-index: 100;
`;
const DownloadButton = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background-color: ${props => props.theme.focusBackgroundColor};
  }

  &:focus {
    background-color: ${props => props.theme.focusBackgroundColor};
  }
`;

const CSVDownloadIcon = styled(DownloadIcon)`
  pointer-events: none;
  path {
    fill: ${props => props.theme.svgDefaultColor};
  }
`;

const ChartHeader = styled.div`
  display: flex;
  margin-top: 15px;
  height: 40px;
`;

const ChartChangeContainer = styled.div`
  visibility: ${props => (!props.hidden === false ? "hidden" : "visible")};
  display: flex;
  flex-direction: column;
  margin-right: 16px;
`;

const ChartChangeTitle = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.7);
`;

const loadingAnimation = keyframes`
  50%   {opacity: 0.5;};
  75%  {opacity: 0.75;};
  100% {opacity: 1;};
`;

const ChartChangeLabel = styled.div`
  margin-top: 6px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  font-feature-settings: "ss01" on, "calt" off;
  color: rgba(0, 0, 0, 0.5);
  .child-container {
    justify-content: flex-start;
  }
  animation: ${loadingAnimation} 1s linear infinite;
`;

const SelectTimeRangeButtonContainer = styled.div`
  visibility: ${props => (!props.hidden === false ? "hidden" : "visible")};
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;

const SelectTimeRangeButton = styled.button`
  background-color: transparent;
  height: 16px;
  padding: 0;
  border: 0;
  outline: 0;
  font-style: normal;
  font-weight: bold;
  font-size: 11px;
  line-height: 13px;
  text-align: right;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.5);
`;

const SelectTimeRangeButtonIcon = styled(DownArrowIcon)`
  margin-left: 3px;
  margin-bottom: 1px;
`;

const ValueTabSkeletonLoaderComponent = () => {
  const currentChartTimeRangeText = "All-Time";
  return (
    <SkeletonLoaderContainer>
      <DownloadButtonContainer>
        <DownloadButton>
          <CSVDownloadIcon></CSVDownloadIcon>
        </DownloadButton>
      </DownloadButtonContainer>
      <LineChartSkeletonLoaderDetailsContainer>
        <ChartHeader>
          <ChartChangeContainer>
            <ChartChangeTitle>{i18n.t("dayChange")}</ChartChangeTitle>
            <ChartChangeLabel>{"XXXX"}</ChartChangeLabel>
          </ChartChangeContainer>
          <ChartChangeContainer>
            <ChartChangeTitle>{currentChartTimeRangeText}</ChartChangeTitle>
            <ChartChangeLabel>{"XXXX"}</ChartChangeLabel>
          </ChartChangeContainer>
          <SelectTimeRangeButtonContainer>
            <SelectTimeRangeButton>
              {currentChartTimeRangeText}
              <SelectTimeRangeButtonIcon />
            </SelectTimeRangeButton>
          </SelectTimeRangeButtonContainer>
        </ChartHeader>
        <LineChartSkeletonLoaderContainer>
          <LineChartSkeleton
            chartHeight={120}
            onHoverOverSection={() => {}}
            chartPadding={{
              left: 0,
              right: 0,
              top: 20,
              bottom: 3
            }}
            isWithinDetails
          />
        </LineChartSkeletonLoaderContainer>
      </LineChartSkeletonLoaderDetailsContainer>
      <GridSkeletonLoaderComponent />
    </SkeletonLoaderContainer>
  );
};
export default ValueTabSkeletonLoaderComponent;
